"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("src/api");
const contractNumbers_1 = require("src/modules/references/purchases/contractNumbers/store/contractNumbers");
const apiGlobalTypes_1 = require("api/types/apiGlobalTypes");
const debouncedMethods_1 = require("api/helper/debouncedMethods");
const helpers_1 = require("core/helpers");
const queryString_1 = require("core/helpers/queryString");
const indexs_1 = require("../helpers/indexs");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const useContractNumbers = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const [state, dispatch] = (0, contractNumbers_1.useContractNumbersReducer)();
    const [showDeleteAlert, setShowDeleteAlert] = (0, react_1.useState)(false);
    const [toDeleteId, setToDeleteId] = (0, react_1.useState)(null);
    const isMounted = (0, react_1.useRef)(false);
    const [isExportingExcel, setIsExportingExcel] = (0, react_1.useState)(false);
    const [showFilter, setShowFilter] = (0, react_1.useState)(false);
    const createdAtFrom = localStorage.getItem('createdAtFrom');
    const createdAtTo = localStorage.getItem('createdAtTo');
    const [loadingPurchaseUsers, setLoadingPurchaseUsers] = (0, react_1.useState)(false);
    const [purchaseUsers, setPurchaseUsers] = (0, react_1.useState)([]);
    const fileDownload = async (type) => {
        if (type === 'excel')
            setIsExportingExcel(true);
        const file = await api_1.ContractNumberApi.getContractNumbersFiles({ type });
        if (file)
            open(file.data?.link);
        if (type === 'excel')
            setIsExportingExcel(false);
        return file;
    };
    const filter = (name, value, filterValues) => {
        getContractNumbers({ ...filterValues, [name]: value, page: 1 }).then();
    };
    const navigatePagination = (page, values) => {
        getContractNumbers({ ...values, page }).then();
    };
    const selectPerPage = (perPage, values) => {
        getContractNumbers({ ...values, perPage, page: 1 }).then();
    };
    const debouncedSearch = (name, value, filterValues) => {
        (0, debouncedMethods_1.debouncedOnFunc)({ ...filterValues, [name]: value, page: 1 }, getContractNumbers);
    };
    const deleteAlert = (id) => {
        setShowDeleteAlert(true);
        setToDeleteId(id);
    };
    const getPurchaseUsers = async () => {
        setLoadingPurchaseUsers(true);
        const userData = await api_1.StructuralUnitsUpgradedApi.getHrEmployee({ abbr: 'purchases' });
        if (userData.data !== null) {
            setPurchaseUsers(userData.data.map(user => {
                return {
                    id: user.userId || '',
                    label: user.name || ''
                };
            }));
        }
        setLoadingPurchaseUsers(false);
    };
    const getContractNumbers = async (values) => {
        dispatch({ type: 'SEND_CONTRACT_NUMBERS_REQUEST' });
        const filterParams = (0, indexs_1.transformContractNumbersParamsToFilterParams)(values);
        const contractNumbers = await api_1.ContractNumberApi.getContractNumbers(filterParams);
        if (isMounted?.current) {
            navigate('/references/purchases/contract-numbers' + (0, queryString_1.stringify)((0, indexs_1.transformFilterParamsToUrl)(values)), { replace: true });
            dispatch({ type: 'DONE_CONTRACT_NUMBERS_REQUEST', payload: contractNumbers });
        }
    };
    const deleteContractNumber = async (confirm) => {
        setShowDeleteAlert(false);
        if (!toDeleteId || !confirm)
            return setToDeleteId(null);
        dispatch({ type: 'SEND_CONTRACT_NUMBER_DELETE_REQUEST' });
        const contractNumbers = await api_1.ContractNumberApi.deleteItem(toDeleteId);
        const params = (0, queryString_1.parse)(location.search);
        dispatch({ type: 'DONE_CONTRACT_NUMBER_DELETE_REQUEST', payload: { errors: contractNumbers.errors } });
        if (contractNumbers.status === apiGlobalTypes_1.ResponseStatuses.SUCCESS)
            getContractNumbers(params).then();
        setToDeleteId(null);
    };
    const initializeFilterForm = async () => {
        const params = (0, indexs_1.transformUrlToContractNumbersFilterParams)(location.search);
        const additionalParams = { ...params, createdAtTo: params.createdAtTo || createdAtTo || undefined, createdAtFrom: params.createdAtFrom || createdAtFrom || undefined };
        dispatch({ type: 'INITIALIZE_FILTER_FORM', payload: additionalParams });
        if ((0, helpers_1.isAnyFilterValue)(additionalParams))
            setShowFilter(true);
        getContractNumbers(additionalParams).then();
    };
    (0, react_1.useEffect)(() => {
        isMounted.current = true;
        initializeFilterForm().then();
        return () => { isMounted.current = false; };
    }, []);
    return {
        state,
        navigatePagination,
        selectPerPage,
        debouncedSearch,
        deleteAlert,
        deleteContractNumber,
        toDeleteId,
        showDeleteAlert,
        getContractNumbers,
        isExportingExcel,
        fileDownload,
        filter,
        setShowFilter,
        showFilter,
        loadingPurchaseUsers,
        purchaseUsers,
        getPurchaseUsers
    };
};
exports.default = useContractNumbers;
